import { createIcon } from '../../icon';

import DiscordSmallIconSvg from './discord-small.svg';
import DiscordLargeIconSvg from './discord-large.svg';
import GithubSmallIconSvg from './github-small.svg';
import GithubLargeIconSvg from './github-large.svg';
import SkypeSmallIconSvg from './skype-small.svg';
import SkypeLargeIconSvg from './skype-large.svg';
import TwitterSmallIconSvg from './twitter-small.svg';
import TwitterLargeIconSvg from './twitter-large.svg';
import FacebookSmallIconSvg from './facebook-small.svg';
import FacebookLargeIconSvg from './facebook-large.svg';
import YoutubeSmallIconSvg from './youtube-small.svg';
import YoutubeLargeIconSvg from './youtube-large.svg';
import RedditSmallIconSvg from './reddit-small.svg';
import RedditLargeIconSvg from './reddit-large.svg';
import LinkedinSmallIconSvg from './linkedin-small.svg';
import LinkedinLargeIconSvg from './linkedin-large.svg';
import GoogleSmallIconSvg from './google-small.svg';
import GoogleLargeIconSvg from './google-large.svg';
import BaiduSmallIconSvg from './baidu-small.svg';
import BaiduLargeIconSvg from './baidu-large.svg';
import BingSmallIconSvg from './bing-small.svg';
import BingLargeIconSvg from './bing-large.svg';
import YandexSmallIconSvg from './yandex-small.svg';
import YandexLargeIconSvg from './yandex-large.svg';
import AWSSmallIconSvg from './aws-small.svg';
import AWSLargeIconSvg from './aws-large.svg';
import GoogleDriveSmallIconSvg from './google-drive-small.svg';
import GoogleDriveLargeIconSvg from './google-drive-large.svg';
import ZapierSmallIconSvg from './zapier-small.svg';
import ZapierLargeIconSvg from './zapier-large.svg';
import PythonSmallIconSvg from './python-small.svg';
import PythonLargeIconSvg from './python-large.svg';
import NodeSmallIconSvg from './node-small.svg';
import NodeLargeIconSvg from './node-large.svg';
import ThreadsSmallIconSvg from './threads-small.svg';
import ThreadsLargeIconSvg from './threads-large.svg';
import InstagramSmallIconSvg from './instagram-small.svg';
import InstagramLargeIconSvg from './instagram-large.svg';
import TiktokSmallIconSvg from './tiktok-small.svg';
import TiktokLargeIconSvg from './tiktok-large.svg';
import AmazonSmallIconSvg from './amazon-small.svg';
import AmazonLargeIconSvg from './amazon-large.svg';
import WayfairSmallIconSvg from './wayfair-small.svg';
import WayfairLargeIconSvg from './wayfair-large.svg';
import WeChatSmallIconSvg from './we-chat-small.svg';
import WeChatLargeIconSvg from './we-chat-large.svg';
import ChatGPTSmallIconSvg from './chat-gpt-small.svg';
import ChatGPTLargeIconSvg from './chat-gpt-large.svg';

export const DiscordSmallIcon = createIcon(
  DiscordSmallIconSvg,
  'DiscordSmallIcon',
  16
);
export const DiscordLargeIcon = createIcon(
  DiscordLargeIconSvg,
  'DiscordLargeIcon',
  24
);
export const GithubSmallIcon = createIcon(
  GithubSmallIconSvg,
  'GithubSmallIcon',
  16
);
export const GithubLargeIcon = createIcon(
  GithubLargeIconSvg,
  'GithubLargeIcon',
  24
);
export const SkypeSmallIcon = createIcon(
  SkypeSmallIconSvg,
  'SkypeSmallIcon',
  16
);
export const SkypeLargeIcon = createIcon(
  SkypeLargeIconSvg,
  'SkypeLargeIcon',
  24
);
export const TwitterSmallIcon = createIcon(
  TwitterSmallIconSvg,
  'TwitterSmallIcon',
  16
);
export const TwitterLargeIcon = createIcon(
  TwitterLargeIconSvg,
  'TwitterLargeIcon',
  24
);
export const FacebookSmallIcon = createIcon(
  FacebookSmallIconSvg,
  'FacebookSmallIcon',
  16
);
export const FacebookLargeIcon = createIcon(
  FacebookLargeIconSvg,
  'FacebookLargeIcon',
  24
);
export const YoutubeSmallIcon = createIcon(
  YoutubeSmallIconSvg,
  'YoutubeSmallIcon',
  16
);
export const YoutubeLargeIcon = createIcon(
  YoutubeLargeIconSvg,
  'YoutubeLargeIcon',
  24
);
export const RedditSmallIcon = createIcon(
  RedditSmallIconSvg,
  'RedditSmallIcon',
  16
);
export const RedditLargeIcon = createIcon(
  RedditLargeIconSvg,
  'RedditLargeIcon',
  24
);
export const LinkedinSmallIcon = createIcon(
  LinkedinSmallIconSvg,
  'LinkedinSmallIcon',
  16
);
export const LinkedinLargeIcon = createIcon(
  LinkedinLargeIconSvg,
  'LinkedinLargeIcon',
  24
);
export const GoogleSmallIcon = createIcon(
  GoogleSmallIconSvg,
  'GoogleSmallIcon',
  16
);
export const GoogleLargeIcon = createIcon(
  GoogleLargeIconSvg,
  'GoogleLargeIcon',
  24
);
export const BaiduSmallIcon = createIcon(
  BaiduSmallIconSvg,
  'BaiduSmallIcon',
  16
);
export const BaiduLargeIcon = createIcon(
  BaiduLargeIconSvg,
  'BaiduLargeIcon',
  24
);
export const BingSmallIcon = createIcon(BingSmallIconSvg, 'BingSmallIcon', 16);
export const BingLargeIcon = createIcon(BingLargeIconSvg, 'BingLargeIcon', 24);
export const YandexSmallIcon = createIcon(
  YandexSmallIconSvg,
  'YandexSmallIcon',
  16
);
export const YandexLargeIcon = createIcon(
  YandexLargeIconSvg,
  'YandexLargeIcon',
  24
);
export const AWSSmallIcon = createIcon(AWSSmallIconSvg, 'AWSSmallIcon', 16);
export const AWSLargeIcon = createIcon(AWSLargeIconSvg, 'AWSLargeIcon', 24);
export const GoogleDriveSmallIcon = createIcon(
  GoogleDriveSmallIconSvg,
  'GoogleDriveSmallIcon',
  16
);
export const GoogleDriveLargeIcon = createIcon(
  GoogleDriveLargeIconSvg,
  'GoogleDriveLargeIcon',
  24
);
export const ZapierSmallIcon = createIcon(
  ZapierSmallIconSvg,
  'ZapierSmallIcon',
  16
);
export const ZapierLargeIcon = createIcon(
  ZapierLargeIconSvg,
  'ZapierLargeIcon',
  24
);
export const PythonSmallIcon = createIcon(
  PythonSmallIconSvg,
  'PythonSmallIcon',
  16
);
export const PythonLargeIcon = createIcon(
  PythonLargeIconSvg,
  'PythonLargeIcon',
  24
);
export const NodeSmallIcon = createIcon(NodeSmallIconSvg, 'NodeSmallIcon', 16);
export const NodeLargeIcon = createIcon(NodeLargeIconSvg, 'NodeLargeIcon', 24);
export const ThreadsSmallIcon = createIcon(
  ThreadsSmallIconSvg,
  'ThreadsSmallIcon',
  16
);
export const ThreadsLargeIcon = createIcon(
  ThreadsLargeIconSvg,
  'ThreadsLargeIcon',
  24
);
export const InstagramSmallIcon = createIcon(
  InstagramSmallIconSvg,
  'InstagramSmallIcon',
  16
);
export const InstagramLargeIcon = createIcon(
  InstagramLargeIconSvg,
  'InstagramLargeIcon',
  24
);
export const TiktokSmallIcon = createIcon(
  TiktokSmallIconSvg,
  'TiktokSmallIcon',
  16
);
export const TiktokLargeIcon = createIcon(
  TiktokLargeIconSvg,
  'TiktokLargeIcon',
  24
);
export const AmazonSmallIcon = createIcon(
  AmazonSmallIconSvg,
  'AmazonSmallIcon',
  16
);
export const AmazonLargeIcon = createIcon(
  AmazonLargeIconSvg,
  'AmazonLargeIcon',
  24
);
export const WayfairSmallIcon = createIcon(
  WayfairSmallIconSvg,
  'WayfairSmallIcon',
  16
);
export const WayfairLargeIcon = createIcon(
  WayfairLargeIconSvg,
  'WayfairLargeIcon',
  24
);
export const WeChatSmallIcon = createIcon(
  WeChatSmallIconSvg,
  'WeChatSmallIcon',
  16
);
export const WeChatLargeIcon = createIcon(
  WeChatLargeIconSvg,
  'WeChatLargeIcon',
  24
);
export const ChatGPTSmallIcon = createIcon(
  ChatGPTSmallIconSvg,
  'ChatGPTSmallIcon',
  16
);
export const ChatGPTLargeIcon = createIcon(
  ChatGPTLargeIconSvg,
  'ChatGPTLargeIcon',
  24
);
